export default {
  header: {
    about: '關於我們',
    contact: '聯絡我們',
    solutions: '解決方案',
    platform: '平台',
  },
  hero: {
    title: '最新一代無鏡頭感測技術',
    subtitle: 'AI 辨識生理數據・室內外智慧守護',
    description: 'Ailicorn 運用領先業界的 AI 模型，為企業提供精準、快速、安全的跌倒偵測服務',
    learnMore: '了解更多'
  },
  seo: {
    home: {
      title: 'AI 毫米波跌倒偵測平台',
      description: 'AIlicorn 透過隱私優先的毫米波雷達與 AI 模型，為醫療、長照與智慧建築提供即時跌倒偵測與生理監控，協助企業符合安全規範。',
      keywords: 'AI 跌倒偵測, 毫米波感測, 無接觸監測, AIlicorn'
    },
    team: {
      title: 'AIlicorn 專業團隊',
      description: '認識 AIlicorn 的創辦人與 AI 工程師，一起打造隱私優先的跌倒偵測與感測解決方案。',
      keywords: 'AIlicorn 團隊, AI 工程師, 創辦團隊, 領導團隊'
    },
    contact: {
      title: '聯絡 AIlicorn',
      description: '歡迎預約 Demo、討論合作，或取得企業級跌倒偵測系統部署建議，AIlicorn 專人將盡快回覆。',
      keywords: '聯絡 AIlicorn, 跌倒偵測 Demo, 企業 AI 感測'
    }
  },
  team: {
    hero: {
      title: '我們的團隊',
      subtitle: '由充滿熱情的技術專家與創新思維者組成，\n共同打造領先業界的 AI 辨識解決方案',
      stats: {
        clients: '合作企業',
        awards: '產業獎項',
        members: '團隊成員'
      }
    },
    members: {
      liberty: {
        name: 'Liberty',
        title: '創辦人 & CEO',
        description: '中央大學資工所背景，已經獲得數十項創業大賽得獎項目，包含兩岸創業大賽金獎得主，是一名連續創業家，熱衷於將 AI 技術應用於實際生活場景中。',
        skills: [
          '創新創業',
          'AI 新創',
          '商業策略'
        ]
      },
      samuel: {
        name: 'Samuel',
        title: 'COO',
        description: '星舟快充(泓德能源)資深經理，曾任幣想科技營運長、弋揚科技副理，擁有豐富的產品與營運管理經驗，專注於提升團隊效率與產品價值。',
        skills: [
          '營運管理',
          '產品設計',
          '技術領導'
        ]
      },
      vince: {
        name: 'Vince',
        title: '資深 AI 工程師',
        description: '中央大學資工系畢業，擁有多年AI模型開發經驗，專注於深度學習與電腦視覺技術的應用，致力於將先進的AI技術轉化為實際產品。',
        skills: [
          'AI 技術',
          '深度學習',
          '訊號處理'
        ]
      },
      person4: {
        name: 'person4',
        title: '資深 AI 工程師',
        description: '中央大學資工系畢業，擁有多年AI模型開發經驗，專注於深度學習與電腦視覺技術的應用，致力於將先進的AI技術轉化為實際產品。',
        skills: [
          'AI 技術',
          '深度學習',
          '訊號處理'
        ]
      },
      person5: {
        name: 'person5',
        title: '資深 AI 工程師',
        description: '中央大學資工系畢業，擁有多年AI模型開發經驗，專注於深度學習與電腦視覺技術的應用，致力於將先進的AI技術轉化為實際產品。',
        skills: [
          'AI 技術',
          '深度學習',
          '訊號處理'
        ]
      }
    }
  },
  contact: {
    title: '聯絡我們',
    subtitle: '歡迎填寫表單與我們聯繫，我們會盡快回覆您',
    loading: '載入中...'
  },
  features: {
    title: '為什麼選擇 Ailicorn',
    subtitle: '專業 AI 辨識技術，為您的業務創造更多價值',
    items: {
      precision: {
        title: '精製處理',
        description: '運用先進 AI 技術進行高精度訊號處理與深度學習，確保每一筆資料的準確性與安全性。'
      },
      api: {
        title: 'API 整合平台',
        description: '提供完整的 API 接口服務，讓您輕鬆整合至現有系統，快速實現智慧化應用。'
      },
      privacy: {
        title: '隱私保證',
        description: '無鏡頭、無身分驗證，全程保護用戶隱私，讓您安心使用我們的服務。'
      }
    }
  },
  awards: {
    title: '媒體曝光與榮譽獎項',
    subtitle: '專業技術深受肯定，持續為產業創新帶來突破',
    linkLabel: '了解更多',
    items: {
      meet_taipei: {
        title: 'Meet 創業小聚報導',
        subtitle: '不用戴手環、不用裝監視器，艾里空用「毫米波雷達」打造無感照護系統',
        url: 'https://meet.bnext.com.tw/articles/view/53293?'
      },
      ces: {
        title: '2026 CES 全球消費電子展',
        subtitle: '赴美參展',
        url: 'https://www.nhks.com.tw/%E9%83%A8%E8%90%BD%E6%A0%BC/%E7%86%B1%E9%96%80%E8%A9%B1%E9%A1%8C/2026%E7%BE%8E%E5%9C%8B%E6%B6%88%E8%B2%BB%E9%9B%BB%E5%AD%90%E5%B1%95ces%E5%8F%B0%E7%81%A3%E5%8F%83%E5%B1%95%E5%BB%A0%E5%95%86%E5%90%8D%E5%96%AE%E5%A4%A7%E5%85%AC%E9%96%8B/'
      },
      fiti: {
        title: '2024 FITI 創新創業激勵計劃',
        category: '創業潛力獎',
        url: 'https://twpowernews.com/news_pagein.php?iType=1009&n_id=270806'
      },
      innoserve: {
        title: '2024 Vivatech',
        category: '銀牌'
      },
      csmu: {
        title: '2023 中山醫學大學全國大專院校創新、創意及創業競賽',
        category: '創意創業組 第一名'
      },
      cht5g: {
        title: '2023 中華電信智慧創新應用大賽暨5G',
        category: '校園組 最佳應用獎'
      }
    }
  },
  technology: {
    title: '核心技術',
    subtitle: '領先業界的 AI 毫米波技術',
    items: {
      fallDetection: {
        title: '極度精準的跌倒預測',
        description: 'AIlicorn的毫米波能夠應用在任何的場域，並響應最低成本的誤報，讓跌倒的傷害降到最低。',
        altText: '跌倒偵測技術'
      },
      humanRecognition: {
        title: '人體辨識系統',
        description: '無鏡頭、完美保證隱私，卻能模擬人體路徑移動，適用於各種安全監控與醫療應用場景。',
        altText: '骨架偵測技術'
      }
    }
  },
  footer: {
    description: '領先業界的 AIoT 跌倒偵測技術服務商，致力於為企業提供最專業的智慧解決方案。',
    sections: {
      about: {
        title: '關於我們',
        team: '團隊成員'
      },
      services: {
        title: '服務項目',
        processing: '精製處理',
        api: 'API 整合',
        evidence: '電子證據保全',
        custom: '客製化方案'
      },
      contact: {
        title: '聯絡資訊',
        email: 'service@ailicorn.com',
        address: '桃園市中壢區明德路60號(5樓)',
        contactUs: '聯絡我們'
      }
    },
    copyright: '© 2025 艾里空股份有限公司 All rights reserved.'
  }
};
